import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './individual-meter-electricity-meter-digital-lg.svg';
import md from './individual-meter-electricity-meter-digital-md.svg';
import sm from './individual-meter-electricity-meter-digital-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.INDIVIDUAL_METER_ELECTRICITY_METER_DIGITAL,
  label: 'Individueller Stromzähler (digital)',
  shortLabel: 'INDSTROM(D)',
  icons: { sm, md, lg },
  component: component(
    'individual-meter-electricity-meter-digital/IndividualMeterElectricityMeterDigitalDevicePanel.vue',
  ),
  aggregationWidget: {
    enabled: true,
    component: component(
      'individual-meter-electricity-meter-digital/IndividualMeterElectricityMeterDigitalAggregationWidget.vue',
    ),
  },
  defaultMetricNames: ['currentEnergy', 'receivedEnergy', 'currentSummationDelivered'],
  importantMetricNames: ['currentEnergy', 'receivedEnergy', 'currentSummationDelivered'],
  aggregationMetricNames: [
    {
      name: 'currentEnergy',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
    {
      name: 'receivedEnergy',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
    {
      name: 'currentSummationDelivered',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
